

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    label: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    controlClass: { type: String, default: '' },
  },
});
